'use client';

import { InfoTooltip, type InfoTooltipProps } from '@cc-shopping/ui/composites/InfoTooltip';
import { useMonetizingTooltipPageAction, useNonMonetizingTooltipPageAction } from './hooks';

type Props = InfoTooltipProps & {
  driverKey: string;
  segmentActionSection?: string;
  offerId: string;
};

function MonetizingTooltip({ driverKey, segmentActionSection, offerId, ...tooltipProps }: Props) {
  const firePageAction = useMonetizingTooltipPageAction();
  return (
    <InfoTooltip
      {...tooltipProps}
      {...(segmentActionSection && {
        onOpen: () => firePageAction(driverKey, 'open', segmentActionSection),
        onClose: () => firePageAction(driverKey, 'close', segmentActionSection),
        onBlur: () => firePageAction(driverKey, 'close', segmentActionSection),
      })}
    />
  );
}

function NonMonetizingTooltip({
  driverKey,
  segmentActionSection,
  offerId,
  ...tooltipProps
}: Props) {
  const firePageAction = useNonMonetizingTooltipPageAction(offerId);
  return (
    <InfoTooltip
      {...tooltipProps}
      {...(segmentActionSection && {
        onOpen: () => firePageAction(driverKey, 'open', segmentActionSection),
        onClose: () => firePageAction(driverKey, 'close', segmentActionSection),
        onBlur: () => firePageAction(driverKey, 'close', segmentActionSection),
      })}
    />
  );
}

export function DriverValueTooltipLegacy({
  isMonetizing = true,
  ...props
}: Props & { isMonetizing?: boolean }) {
  return isMonetizing ? <MonetizingTooltip {...props} /> : <NonMonetizingTooltip {...props} />;
}
